
import Vue from 'vue';
import Component from 'vue-class-component';
import TInput from '@/lib/form/input/Input.vue';
import TButton from '@/lib/form/button/Button.vue';
import apiClient from '@/app/clients/api-client';
import { toSeconds } from '@/app/plugins/utils';
import { Watch } from 'vue-property-decorator';

@Component({
  name: 'transcripts-popover',
  components: {
    TInput,
    TButton
  },
  props: ['showTimestamp', 'showTranscriptPopover', 'subtitleLanguage']
})
export default class TranscriptsPopover extends Vue {
  transcriptValue = '';
  loader = false;
  transcripts: any = null;
  showTranscriptPopover;
  showTimestamp;
  subtitleLanguage;

  getTranscript() {
    if (this.transcripts !== null) {
      return;
    }
    this.loader = true;

    apiClient
      .fetchVideoSubtitles(this.videoId)
      .then(result => {
        this.transcripts = result.data;
      })
      .catch(error => {
        this.$error(error);
      })
      .finally(() => {
        this.loader = false;
      });
  }

  @Watch('showTranscriptPopover')
  onShowTranscriptPopoverChange() {
    if (this.showTranscriptPopover) {
      this.getTranscript();
    }
  }

  get videoId() {
    return this.$route.params.videoId;
  }

  get transcriptionList() {
    return this.transcripts
      .filter((transcript) => transcript.langCode == (this.subtitleLanguage || 'en'))
      .filter(transcript =>
        transcript.text
          .toLowerCase()
          .includes(this.transcriptValue.toLowerCase())
      )
      .map(transcript => ({
        ...transcript,
        startTime: toSeconds(transcript.startTime),
        endTime: toSeconds(transcript.endTime)
      }));
  }

  onTranscriptSelect(transcript) {
    this.$emit('transcript-select', transcript);
  }
}
